import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import createPersistedState from "vuex-persistedstate";

import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "jky",
      storage: window.localStorage,
      reducer(state) {
        return {
          userInfo: state.userInfo,
          companyInfo: state.companyInfo,
        };
      },
    }),
  ],
  state,
  mutations,
  actions,
});
